const ErrorIcon = () => <i className="icon-cancel-in-circle" />

export default ErrorIcon;